import { useTranslations } from 'contexts/Translation'
import PropTypes from 'prop-types'
import { Row, Col, Text } from '@qonsoll/react-design'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { ApplicationSimpleView } from 'domains/Application/components'

const ApplicationList = (props) => {
  const { applications, isListWithCreate, listView, emptyProps, actions } =
    props

  // [COMPONENT_STATE_HOOKS]
  const [selectedItem, setSelectedItem] = useState(null)

  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()

  // [HANDLERS]
  const onEmptySpaceClick = () => setSelectedItem(null)

  return (
    <Row onClick={onEmptySpaceClick} mx={-3}>
      {applications?.length > 0 ? (
        applications?.map((application, index) => (
          <Col
            mb={4}
            key={application?._id || index}
            cw={listView ? 12 : [12, 6, 4]}>
            <ApplicationSimpleView
              actions={actions}
              index={index}
              isSelected={application?._id === selectedItem}
              onSelect={setSelectedItem}
              application={application}
            />
          </Col>
        ))
      ) : (
        <Col cw={isListWithCreate ? 'auto' : 12}>
          <Text variant="overline" type="secondary">
            {emptyProps?.message || t('No applications have been created yet')}
          </Text>
        </Col>
      )}
    </Row>
  )
}

ApplicationList.propTypes = {
  applications: PropTypes.array,
  isListWithCreate: PropTypes.bool,
  listView: PropTypes.bool,
  emptyProps: PropTypes.object,
  actions: PropTypes.shape({
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    onDoubleClick: PropTypes.func,
    onClick: PropTypes.func
  })
}

export default ApplicationList
